


import linkDirective from '@/shared/directives/link-directive';
import scrollPositionDirective from '@/shared/directives/scroll-position-directive';
import ICategory from '../models/category';
import {IDictionary} from '@/shared/models/interface/dictionary-model';
import CategoryComponent from './CategoryComponent.vue';
import ContentItemsComponent from './ContentItemsComponent.vue';
import PopupComponent from './PopupComponent.vue';
import SubCategoryComponent from './SubCategoryComponent.vue';
import {defineComponent, PropType} from "@vue/composition-api";
import {useMutations, useState} from "vuex-composition-helpers";

declare global {
  interface Window {
    dynamicColorSystem?: {
      applyDynamicColors?: () => void
    }
  }
}

export default defineComponent({
  name: "MoreAboutWidget",
  components: {
    CategoryComponent,
    ContentItemsComponent,
    PopupComponent,
    SubCategoryComponent
  },
  directives: {
    linkDirective,
    scrollPositionDirective
  },
  props: {
    categories: {type: [] as PropType<ICategory[]>, required: true},
    labels: {type: Object as PropType<IDictionary<string>>, required: true},
  },
  setup: () => {
    const {
      selectedCategory,
      subCategories,
      selectedSubCategory,
      subContentItems
    } = useState(['selectedCategory', 'subCategories', 'selectedSubCategory', 'subContentItems'])

    const {
      resetSubCategory,
      selectCategory,
      selectSubCategory,
      closeSubCategories
    } = useMutations(['resetSubCategory', 'selectCategory', 'selectSubCategory', 'closeSubCategories'])

    return {
      selectedCategory,
      subCategories,
      selectedSubCategory,
      subContentItems,
      resetSubCategory,
      selectCategory,
      selectSubCategory,
      closeSubCategories
    }
  }
})
